<template>
  <tutorial v-on:end-tutorial="$router.push('/home')"></tutorial>
</template>

<script>
  import Tutorial from '@/components/tutorial/Tutorial'
  export default {
    name: 'TutorialSection',
    components: {
      Tutorial
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/tutorial/TutorialSection.vue